// SPDX-License-Identifier: MIT
// /connecter — SP-2 hub: Claude parcours (live) + BYOAI why-tip + "Autres IA
// à venir" showcase + demoted API-key picker behind a discreet advanced toggle.
//
// SP-1 inline style.* debt → now a .connecter CSS rule in components.css.
import { renderHeader } from '../components/header';
import { renderFooter } from '../components/footer';
import { renderConnectClaude } from '../components/connect-claude';
import { renderTerminalJourney } from '../components/terminal-journey';
import { renderConnectSoon } from '../components/connect-soon';
import {
  renderConnectSurfaceShell,
  hydrateDevProvider,
  renderConnectWhyTip,
} from '../components/connect-surface';
import { t } from '../i18n/t';
import type { Locale } from '../i18n/detect';

export interface ConnecterPageOptions {
  locale?: Locale;
  // Authed chrome (best-effort) — ✦ idées pill + account menu when signed in.
  user?: { email: string };
  onSignOut?: () => void | Promise<void>;
}

export function renderConnecterPage(opts: ConnecterPageOptions = {}): DocumentFragment {
  const frag = document.createDocumentFragment();
  frag.appendChild(renderHeader({ locale: opts.locale, activePath: '/connecter', currentRung: 'terminal', user: opts.user, onSignOut: opts.onSignOut }));

  const main = document.createElement('main');
  main.className = 'connecter';
  main.setAttribute('data-component', 'connecter-page');

  // 0. "La façon Terminal" journey — explains the REAL flow (install once → converse
  //    → Claude builds + ships), the missing "how do I deploy Genesis" piece. Its CTA
  //    scrolls down to the connect-claude stepper below (the actionable "do it" part).
  main.appendChild(renderTerminalJourney());

  // 1. Claude parcours — live (subscription-first, BYOAI) — the actionable stepper
  main.appendChild(renderConnectClaude());

  // 2. "Pourquoi connecter mon Claude ?" rationale tip (moved from welcome rail)
  main.appendChild(renderConnectWhyTip());

  // 3. "Autres IA — à venir" showcase (monogram glyphs, no brand logos)
  main.appendChild(renderConnectSoon());

  // 4. Demoted API-key picker (hedge: kept but hidden until user toggles)
  const adv = document.createElement('div');
  adv.setAttribute('data-component', 'connecter-advanced');
  adv.className = 'connecter-advanced';

  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.setAttribute('data-component', 'connecter-advanced-toggle');
  toggle.className = 'connecter-advanced__toggle';
  toggle.textContent = t('connecter.soon.advancedToggle');
  toggle.setAttribute('aria-expanded', 'false');

  const slot = document.createElement('div');
  slot.className = 'connect-ai-slot';
  slot.setAttribute('data-component', 'connect-ai-slot');
  slot.hidden = true;
  slot.appendChild(renderConnectSurfaceShell());
  void hydrateDevProvider(slot);

  toggle.addEventListener('click', () => {
    slot.hidden = !slot.hidden;
    toggle.setAttribute('aria-expanded', String(!slot.hidden));
  });
  adv.append(toggle, slot);
  main.appendChild(adv);

  frag.appendChild(main);
  frag.appendChild(renderFooter());
  return frag;
}
